import { render, staticRenderFns } from "./benefitSummary.vue?vue&type=template&id=0ab1658f&scoped=true"
import script from "./benefitSummary.vue?vue&type=script&lang=js"
export * from "./benefitSummary.vue?vue&type=script&lang=js"
import style0 from "./benefitSummary.vue?vue&type=style&index=0&id=0ab1658f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab1658f",
  null
  
)

export default component.exports